import { validateForUI } from 'common/helpers/jsonValidator';

const pickupSchema = {
  type: 'object',
  properties: {
    inventoryLocationId: { type: 'string', format: 'uuid' }
  },
  required: ['email'],
  additionalProperties: false
};

export const validatePickup = (pickup) => {
  const errors = validateForUI(pickupSchema, pickup);
  return errors;
};
